import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Comprehensive ResizeObserver error suppression
// Patch ResizeObserver to prevent the error at its source
(function() {
  const OriginalResizeObserver = window.ResizeObserver;
  
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
  
  // Also suppress any errors that still slip through
  const errorHandler = (event) => {
    if (
      event.message &&
      (event.message.includes('ResizeObserver') ||
       event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
       event.message === 'ResizeObserver loop limit exceeded')
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  };
  
  window.addEventListener('error', errorHandler);
  
  // Override console.error to filter ResizeObserver
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const message = args.join(' ');
    if (message.includes('ResizeObserver')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
